import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "ArtistDetail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$artistDetail, _ctx$artistDetail$art;

  var _component_ListDetailTop = _resolveComponent("ListDetailTop");

  var _component_ListDetailNav = _resolveComponent("ListDetailNav");

  var _component_ArtistListDetail = _resolveComponent("ArtistListDetail");

  var _component_VideoList = _resolveComponent("VideoList");

  var _component_ArtistSyno = _resolveComponent("ArtistSyno");

  var _component_Loading = _resolveComponent("Loading");

  return _ctx.route.params.id == ((_ctx$artistDetail = _ctx.artistDetail) === null || _ctx$artistDetail === void 0 ? void 0 : (_ctx$artistDetail$art = _ctx$artistDetail.artist) === null || _ctx$artistDetail$art === void 0 ? void 0 : _ctx$artistDetail$art.id) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 歌手头部详情 "), _createVNode(_component_ListDetailTop, {
    detailTopInfo: _ctx.artistDetail.artist,
    detailType: "歌手"
  }, null, 8
  /* PROPS */
  , ["detailTopInfo"]), _createCommentVNode(" 导航 "), _createVNode(_component_ListDetailNav, {
    navList: _ctx.navList,
    onTitleClick: _ctx.titleClick,
    style: {
      "margin-bottom": "20px"
    }
  }, null, 8
  /* PROPS */
  , ["navList", "onTitleClick"]), _createCommentVNode(" 歌手热门50首 "), _ctx.isShow == 0 ? (_openBlock(), _createBlock(_component_ArtistListDetail, {
    key: 0,
    albumList: _ctx.artistDetail.album
  }, null, 8
  /* PROPS */
  , ["albumList"])) : _ctx.isShow == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 歌手mv "), _createVNode(_component_VideoList, {
    videoList: _ctx.artistDetail.mv,
    isShowLoading: false,
    isScroll: false,
    isBlod: true
  }, null, 8
  /* PROPS */
  , ["videoList"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : _ctx.isShow == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createCommentVNode(" 歌手详情描述 "), _createVNode(_component_ArtistSyno, {
    artistDesc: _ctx.artistDetail.desc
  }, null, 8
  /* PROPS */
  , ["artistDesc"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : (_openBlock(), _createBlock(_component_Loading, {
    key: 3
  }))])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }));
}